<template>
  <div class="chat-page">
    <van-nav-bar title="在线客服" class="chat-nav" left-arrow @click-left="back" />
    <div ref="messageList" class="message-list">
      <div class="welcome-card">
        <img src="/img/mine/kefu.png" alt="客服" />
        <strong>在线客服</strong>
        <span>您好，请问有什么可以帮助您？</span>
      </div>
      <div v-for="item in messages" :key="item.id" class="message-row" :class="item.sender">
        <img v-if="item.sender === 'admin'" src="/img/mine/kefu.png" alt="客服" class="avatar" />
        <div class="message-content">
          <div class="bubble">{{ item.message }}</div>
          <time>{{ formatTime(item.create_time) }}</time>
        </div>
      </div>
    </div>
    <form class="composer" @submit.prevent="sendMessage">
      <van-field v-model.trim="draft" maxlength="1000" placeholder="请输入消息……" @keyup.enter.native="sendMessage" />
      <button type="submit" :disabled="sending || !draft">发送</button>
    </form>
  </div>
</template>

<script>
export default {
  data() { return { messages: [], draft: '', sending: false, timer: null, lastCount: 0 }; },
  methods: {
    back() { this.$router.go(-1); },
    loadMessages(silent) {
      return this.$http({ method: 'get', url: 'user_chat_list' }).then(res => {
        if (res && res.code === 200) {
          this.messages = res.data.messages || [];
          if (!silent || this.messages.length !== this.lastCount) this.$nextTick(this.scrollBottom);
          this.lastCount = this.messages.length;
        }
      });
    },
    sendMessage() {
      if (!this.draft || this.sending) return;
      const message = this.draft;
      this.sending = true;
      this.$http({ method: 'post', url: 'user_chat_send', data: { message } }).then(res => {
        if (res && res.code === 200) { this.draft = ''; return this.loadMessages(false); }
        this.$toast(res && res.msg ? res.msg : '发送失败');
      }).finally(() => { this.sending = false; });
    },
    scrollBottom() { const el = this.$refs.messageList; if (el) el.scrollTop = el.scrollHeight; },
    formatTime(timestamp) {
      if (!timestamp) return '';
      const date = new Date(Number(timestamp) * 1000);
      return date.toLocaleString([], { month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit' });
    }
  },
  created() { this.loadMessages(false); this.timer = window.setInterval(() => this.loadMessages(true), 3000); },
  beforeDestroy() { window.clearInterval(this.timer); }
};
</script>

<style lang="less" scoped>
.chat-page { display:flex; flex-direction:column; height:100%; padding-bottom:100px; background:#f5f3f7; }
.chat-nav { flex:none; background:linear-gradient(135deg,#7c6ff0,#db6ea9) !important; }
.message-list { flex:1; overflow-y:auto; padding:24px 22px 150px; }
.welcome-card { display:flex; flex-direction:column; align-items:center; margin:0 auto 30px; color:#8e8798; font-size:22px; }
.welcome-card img { width:76px; height:76px; margin-bottom:8px; border-radius:50%; }.welcome-card strong { color:#3f3948; font-size:27px; }.welcome-card span { margin-top:5px; }
.message-row { display:flex; align-items:flex-end; gap:12px; margin-bottom:22px; }.message-row.user { justify-content:flex-end; }.avatar { width:58px; height:58px; border-radius:50%; }
.message-content { max-width:72%; }.bubble { padding:16px 20px; border-radius:22px 22px 22px 6px; background:#fff; box-shadow:0 6px 18px rgba(45,35,65,.07); color:#36303e; font-size:25px; line-height:1.5; word-break:break-word; }
.user .bubble { border-radius:22px 22px 6px 22px; background:linear-gradient(135deg,#7c6ff0,#db6ea9); color:#fff; }.message-content time { display:block; margin-top:5px; color:#aaa3b1; font-size:18px; }.user time { text-align:right; }
.composer { position:fixed; left:0; right:0; bottom:100px; z-index:9000; display:flex; align-items:center; gap:12px; padding:14px 18px calc(14px + env(safe-area-inset-bottom)); border-top:1px solid #ece7ef; background:rgba(255,255,255,.96); box-shadow:0 -7px 25px rgba(40,32,55,.07); }
.composer .van-field { flex:1; padding:14px 18px; border-radius:22px; background:#f2eff4; font-size:24px; }.composer button { flex:none; height:58px; padding:0 28px; border:0; border-radius:999px; background:linear-gradient(135deg,#7c6ff0,#db6ea9); color:#fff; font-size:24px; font-weight:700; }.composer button:disabled { opacity:.45; }
</style>
